import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";


@Component({
  selector: 'page-previous-schools-students',
  templateUrl: 'previous-schools-students.html',
})
export class PreviousSchoolsStudentsPage {

  FUserId:any;
  FSchoolId:any;
  FPreviousSchoolId:any;
  StudentsDataAdm:any;
  StudentsData1Adm:any;
  StudentsDataEnq:any;
  StudentsData1Enq:any;

  DataSearch:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public storage: Storage,
              public platform: Platform,
              public service:ServiceProvider) {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData'), this.storage.get('UserData')]).then(values => {
        this.FUserId = values[0]['FUserId'];

        this.FSchoolId=navParams.get('FSchoolId');
        this.FPreviousSchoolId=navParams.get('FPreviousSchoolId');

        this.loadStudentsAdm();

        this.loadStudentsEnq();
      })
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PreviousSchoolsStudentsPage');
  }

  loadStudentsAdm(){
    this.StudentsDataAdm=[];
    this.service.httpcall('app_web_service/get_students_by_previous_school_admission?SchoolId='+this.FSchoolId+'&PreSchoolId='+this.FPreviousSchoolId).subscribe(data => {
      console.log(data);
      if(data['response']=='success'){
        this.StudentsData1Adm = data['data'];
        this.StudentsDataAdm = this.StudentsData1Adm;
      }else{
        this.service.showAlert(data['response'],data['error_description']);
      }
    },error =>{
      this.service.showAlert('Timeout',"Please Try Again!");
    })
  }

  loadStudentsEnq(){
    this.StudentsDataEnq=[];
    this.service.httpcall('app_web_service/get_students_by_previous_school_enquiry?SchoolId='+this.FSchoolId+'&PreSchoolId='+this.FPreviousSchoolId).subscribe(data => {
      console.log(data);
      if(data['response']=='success'){
        this.StudentsData1Enq = data['data'];
        this.StudentsDataEnq= this.StudentsData1Enq;
      }else{
        this.service.showAlert(data['response'],data['error_description']);
      }
    },error =>{
      this.service.showAlert('Timeout',"Please Try Again!");
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadStudentsAdm();
    this.loadStudentsEnq();
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  searchData(ev: any) {
    // Reset items back to all of the items
    this.StudentsDataAdm = this.StudentsData1Adm;


    // set val to the value of the searchbar
    let valAdm = ev.target.value;
    // if the value is an empty string don't filter the items
    if (valAdm && valAdm.trim() != '') {
      this.StudentsData1Adm = this.StudentsData1Adm.filter((item) => {
        return (item.StudentName.toLowerCase().indexOf(valAdm.toLowerCase()) > -1);
      })
    }

    this.StudentsDataEnq = this.StudentsData1Enq;
    let valEnq = ev.target.value;
    // if the value is an empty string don't filter the items
    if (valEnq && valEnq.trim() != '') {
      this.StudentsData1Enq = this.StudentsData1Enq.filter((item) => {
        return (item.StudentName.toLowerCase().indexOf(valEnq.toLowerCase()) > -1);
      })
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/previous-schools-students/previous-schools-students.ts